window.addEventListener('load', (event) => {
  if (document.querySelector('#email_signup')) {
    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true,
      success: function ($form) {
        console.log("Success!")
        console.log($form)
      }
    });
  }

  let archiveForms = [
    {
      containerSelector: '.archive-collection-form-gate',
      formSelector: '#gate_signup',
      storageKey: 'opted'
    },
    {
      containerSelector: '.archive-collection-form-gate-bfcm',
      formSelector: '#gate_signup_bfcm',
      storageKey: 'opted_bfcm'
    },
  ];

  archiveForms.forEach(form => {
    const containerEl = document.querySelector(form.containerSelector);
    if (containerEl) {
      if (localStorage.getItem(form.storageKey) != undefined) {
        containerEl.classList.add('opted');
      } else {
        containerEl.classList.remove('hide');
        containerEl.classList.add('optin');
      }

      KlaviyoSubscribe.attachToForms(form.formSelector, {
        hide_form_on_success: false,
        extra_properties: {
          $source: '$embed',
          $method_type: "Klaviyo Form",
          $method_id: 'embed',
          $consent_version: 'Embed default text'
        },
        success: function ($form) {
          formGateSection.classList.add('opted');
          localStorage.setItem(form.storageKey, "true");
        }
      });
    }
  });
});
